import { render, staticRenderFns } from "./PersonCenter.vue?vue&type=template&id=208525ec&scoped=true&"
import script from "./PersonCenter.vue?vue&type=script&lang=js&"
export * from "./PersonCenter.vue?vue&type=script&lang=js&"
import style0 from "./PersonCenter.vue?vue&type=style&index=0&id=208525ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208525ec",
  null
  
)

export default component.exports